import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Product, WindowRef } from '@spartacus/core';
import { isEmpty } from '../../core/services/simple-tools';
import { SearchProductService } from './core/search-product.service';
import { ToasterService } from '../toaster/toaster.service';
import { SearchProductRequest } from './core/search-product.model';
import { initialStatus, loadingStatus } from '../../core/models/request-status.model';

@Component({
  selector: 'search-product',
  templateUrl: './search-product.component.html',
  styleUrl: './search-product.component.scss',
  standalone: false,
})
export class SearchProductComponent implements OnInit, OnDestroy {
  @ViewChild('container') container!: HTMLFormElement;
  @Output() _onProductSelected = new EventEmitter<Product>();

  form: FormGroup = this.fb.group({
    search: ['', []],
  });

  subscription = new Subscription();
  searchProductRequest$ = new BehaviorSubject<SearchProductRequest>(initialStatus);
  products$ = new BehaviorSubject<Product[]>([]);
  showProducts$ = new BehaviorSubject<boolean>(false);

  constructor(
    private fb: FormBuilder,
    private searchProductService: SearchProductService,
    private toasterService: ToasterService,
    private winRef: WindowRef,
  ) {}

  ngOnInit(): void {
    this.listnerSearch();
    this.listenToOutsideClicks();

    // this.form.get('search')?.setValue('431PSL6252-MARC');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  listnerSearch() {
    let typingTimer: any;
    const typingDelay = 1000;

    this.subscription.add(
      this.form.valueChanges.subscribe(() => {
        clearTimeout(typingTimer);

        typingTimer = setTimeout(() => {
          this.submit();
        }, typingDelay);
      }),
    );
  }

  listenToOutsideClicks(): void {
    this.winRef.isBrowser() &&
      document.addEventListener('click', () => {
        if (this.showProducts$.value) {
          this.showProducts$.next(false);
          this.form.get('search')?.setValue('');
        }
      });
  }

  submit(): void {
    const query = this.form.get('search')?.value;

    if (!isEmpty(query)) {
      this.searchProductRequest$.next(loadingStatus);

      this.searchProductService.search(query).subscribe(response => {
        if (response.hasError) {
          this.toasterService.displayError(response.message!);
        }

        this.searchProductRequest$.next(response);
        this.showProducts$.next(true);
      });
    }
  }

  selectProduct(product: Product): void {
    this._onProductSelected.emit(product);
  }
}
